import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import { routeSeo, getBranchSeo } from '@/seo/routes'
import { branches } from '@/data/mayonSite'
import { applySeo } from '@/seo/headManager'

Vue.use(VueRouter)

const hashToId = (hash) => {
  if (!hash || hash.charAt(0) !== '#') return ''
  try {
    return decodeURIComponent(hash.slice(1))
  } catch (error) {
    return ''
  }
}

const scrollToHash = (hash) => new Promise((resolve) => {
  if (!hash || typeof document === 'undefined') {
    resolve({ x: 0, y: 0 })
    return
  }

  Vue.nextTick(() => {
    window.requestAnimationFrame(() => {
      const id = hashToId(hash)
      const target = id ? document.getElementById(id) : null
      if (!target) {
        resolve({ x: 0, y: 0 })
        return
      }
      const y = target.getBoundingClientRect().top + window.pageYOffset - 88
      window.scrollTo({ behavior: 'smooth', top: y })
      resolve(false)
    })
  })
})

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { seo: routeSeo.home }
  },
  {
    path: '/packages',
    name: 'packages',
    component: () => import(/* webpackChunkName: "packages" */ '../views/PackagesView.vue'),
    meta: { seo: routeSeo.packages }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '../views/ServicesView.vue'),
    meta: { seo: routeSeo.services }
  },
  {
    path: '/branches',
    name: 'branches',
    component: () => import(/* webpackChunkName: "branches" */ '../views/BranchesView.vue'),
    meta: { seo: routeSeo.branches }
  },
  {
    path: '/branches/:id',
    name: 'branch-detail',
    component: () => import(/* webpackChunkName: "branch-detail" */ '../views/BranchDetailView.vue'),
    beforeEnter(to, from, next) {
      if (branches.some(branch => branch.id === to.params.id)) next()
      else next({ name: 'not-found', params: { pathMatch: to.path.slice(1) }, replace: true })
    },
    meta: { seo: getBranchSeo }
  },
  {
    path: '/hmo-partners',
    name: 'hmo-partners',
    component: () => import(/* webpackChunkName: "hmo-partners" */ '../views/HmoPartnersView.vue'),
    meta: { seo: routeSeo.hmoPartners }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { seo: routeSeo.about }
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFoundView,
    meta: { seo: routeSeo.notFound }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return scrollToHash(to.hash)
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  const seo = to.meta && to.meta.seo
  applySeo(typeof seo === 'function' ? seo(to) : (seo || routeSeo.notFound))
})

export default router
